<p-toast key="main"></p-toast>

<div class="row mb-4" *ngIf="tenant">
  <app-tenant-html-form
    [tenantModel]="editTenantModel"
    (submitedValue)="update($event)"
  ></app-tenant-html-form>
</div>
